module.exports = __webpack_public_path__ + "empty_history.png?aa75949496cf596336e7988bf5c24e11";